/** When your routing table is too long, you can split it into small modules */

import Layout from '@/views/layout/TheLayout.vue';

const settingsRoutes = {
  path: '/settings',
  component: Layout,
  redirect: 'noredirect',
  name: 'Settings',
  meta: {
    priority: 999,
    title: 'route.settings',
    icon: 'mdi-settings',
    groups: ['admin'],
  },
  parentId: 'Settings',
  children: [
    {
      path: '/settings/admin',
      component: () => import('@/views/components/Settings/Users.vue'),
      name: 'SettingsUsers',
      meta: { title: 'route.setting.users', groups: ['admin'], noCache: true },
      parentId: 'Settings',
    },
    {
      path: '/settings/tags',
      component: () => import('@/views/components/Settings/UsersTags.vue'),
      name: 'SettingsUsersTags',
      meta: { title: 'route.setting.tags', groups: ['admin'], noCache: true },
      parentId: 'Settings',
    },
    {
      path: '/settings/groups',
      component: () => import('@/views/components/Settings/Groups.vue'),
      name: 'SettingsGroups',
      meta: { title: 'route.setting.groups', groups: ['admin'], noCache: true },
      parentId: 'Settings',
    },
    {
      path: '/settings/departments',
      component: () => import('@/views/components/Settings/Departments.vue'),
      name: 'SettingsDepartments',
      meta: { title: 'route.setting.departments', groups: ['admin'], noCache: true },
      parentId: 'Settings',
    },
    {
      path: '/settings/companies',
      component: () => import('@/views/components/Settings/Companies.vue'),
      name: 'SettingsCompanies',
      meta: { title: 'route.setting.companies', groups: ['admin'], noCache: true },
      parentId: 'Settings',
    },
    {
      path: '/settings/dropdowns',
      component: () => import('@/views/components/Settings/Dropdowns.vue'),
      name: 'SettingsDropdowns',
      meta: { title: 'route.setting.dropdowns', groups: ['admin'], noCache: true },
      parentId: 'Settings',
    },
    {
      path: '/settings/registries',
      component: () => import('@/views/components/Settings/Registries.vue'),
      name: 'SettingsRegistries',
      meta: { title: 'route.setting.registries', groups: ['yester.admin'], noCache: true },
      parentId: 'Settings',
    },
    {
      path: '/settings/menu-items',
      component: () => import('@/views/components/Settings/MenuItems.vue'),
      name: 'MenuItems',
      meta: { title: 'route.setting.menuItems', groups: ['yester.admin'], noCache: true },
    },
    {
      path: '/settings/processes',
      component: () => import('@/views/components/Settings/Processes.vue'),
      name: 'SettingsProcesses',
      meta: { title: 'route.setting.processes', groups: ['yester.admin'], noCache: true },
      parentId: 'Settings',
    },
    {
      path: '/settings/caseconfiguration',
      component: () => import('@/views/components/Settings/CaseConfiguration.vue'),
      name: 'SettingsProcesses',
      meta: { title: 'route.setting.caseconfiguration', groups: ['yester.admin'], noCache: true },
      parentId: 'Settings',
    },
    {
      path: '/settings/forms',
      component: () => import('@/views/components/Settings/Forms.vue'),
      name: 'SettingsForms',
      meta: { title: 'route.setting.forms', groups: ['yester.admin'], noCache: true },
      parentId: 'Settings',
    },
    {
      path: '/settings/formbuilder',
      component: () => import('@/views/components/Settings/FormBuilder.vue'),
      name: 'SettingsFormBuilder',
      meta: { title: 'route.setting.formbuilder', groups: ['yester.admin'], noCache: true },
      parentId: 'Settings',
    },
    {
      path: '/settings/i18n',
      component: () => import('@/views/components/Settings/I18n.vue'),
      name: 'SettingsI18n',
      meta: { title: 'route.setting.i18n', groups: ['yester.admin'], noCache: true },
      parentId: 'Settings',
    },
    {
      path: '/settings/jobs',
      component: () => import('@/views/components/Jobs.vue'),
      name: 'Jobs',
      meta: {
        groups: ['yester.admin'],
        title: 'route.jobs',
        noCache: true,
      },
      parentId: 'Settings',
    },
    // {
    //   path: '/settings/processes',
    //   component: () => import('@/views/components/Settings/Processes.vue'),
    //   name: 'SettingsProcesses',
    //   meta: { title: 'route.setting.processes', groups: ['admin'], noCache: true },
    // },
    // {
    //   path: '/settings/configuration',
    //   component: () => import('@/views/components/Settings/Configuration.vue'),
    //   name: 'SettingsConfiguration',
    //   meta: { title: 'route.setting.configuration', groups: ['admin'], noCache: true },
    // },
  ],
};

export default settingsRoutes;
